import { create } from 'zustand';

import type { ShapeId, WallShape } from './types';

export type ShapeHandle = 'left' | 'right' | 'top' | 'bottom' | 'start' | 'end' | null;

interface TextInputDraft {
  x: number;
  y: number;
  text: string;
}

interface BoardDrawingState {
  draftShape: WallShape | null;
  localShapes: WallShape[];
  selectedShapeHandle: ShapeHandle;
  selectedShapeId: ShapeId | null;
  textInputDraft: TextInputDraft | null;
}

interface BoardDrawingActions {
  addLocalShape: (shape: WallShape) => void;
  clearDraftShape: () => void;
  resetBoardDrawing: () => void;
  setDraftShape: (draftShape: WallShape | null) => void;
  setSelectedShape: (selectedShapeId: ShapeId | null, selectedShapeHandle?: ShapeHandle) => void;
  setTextInputDraft: (textInputDraft: TextInputDraft | null) => void;
  updateDraftShape: (attributes: Record<string, unknown>) => void;
}

export type BoardDrawingStore = BoardDrawingState & BoardDrawingActions;

const initialState: BoardDrawingState = {
  draftShape: null,
  localShapes: [],
  selectedShapeHandle: null,
  selectedShapeId: null,
  textInputDraft: null,
};

export const useBoardDrawingStore = create<BoardDrawingStore>((set) => ({
  ...initialState,
  addLocalShape: (shape) =>
    set((state) => ({ localShapes: [...state.localShapes, shape], selectedShapeId: shape.id })),
  clearDraftShape: () => set({ draftShape: null }),
  resetBoardDrawing: () => set(initialState),
  setDraftShape: (draftShape) => set({ draftShape }),
  setSelectedShape: (selectedShapeId, selectedShapeHandle = null) =>
    set({ selectedShapeHandle, selectedShapeId }),
  setTextInputDraft: (textInputDraft) => set({ textInputDraft }),
  updateDraftShape: (attributes) =>
    set((state) => ({
      draftShape: state.draftShape
        ? { ...state.draftShape, attributes: { ...state.draftShape.attributes, ...attributes } }
        : null,
    })),
}));
